import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fileInputParams, FunctionsService, FileFormsService, HttpService, MessageService, SessionService, fileFormsParams, TableConfiguration, TableColumns, params, LocalStorageService } from 'brainloper-ui';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { ComponentEquipment } from 'app/models2/maintenance/component';
import { GenericResponse } from 'app/models2/commos/generic-response';

@Component({
  selector: 'app-modal-equipment',
  templateUrl: './modal-equipment.component.html',
  styleUrls: ['./modal-equipment.component.scss']
})
export class ModalEquipmentComponent implements OnInit {

  private urlPostComponentes: string = `${EndpointDictionary.ComponentEquipment.CRUD_COMPONENT_EQUIPMENT_DATA}`

  public numeroComponentes = []
  public formComponentes = []
  public componentsForm: UntypedFormGroup
  private file = null
  public companyId = this.storage.get<number>('companyId')
  private titleLabel: string

  private dataComponentes: Array<ComponentEquipment>

  private fileOld: fileFormsParams[] = [{
    id: 'old',
    value: ''
  }]

  //tabla componentes

  private paramsCompoentes: params[] = [{ id: 'equipmentId', value: '' }]

  private titleComponentes: string = screen.width > 450 ? 'Componentes' : ''
  private recargarTablaComponentes = new EventEmitter<any>()
  private configurationComponentes: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'id'
  }
  private columnasComponentes: TableColumns<ComponentEquipment>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center',
        width: screen.width > 600 ? '50%' : '80%',
      },
    }
  ]
  //imagen
  public fileInputComponente: fileInputParams = {
    typeFile: "imagen",
    input: "formulario",
    label: "imagen",
    edit: true,
    style: {
      width: '100%'
    }
  }


  constructor(
    public dialogRef: MatDialogRef<ModalEquipmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private formFile: FileFormsService,
    private http: HttpService,
    private message: MessageService,
    private formBulier: UntypedFormBuilder,
    private session: SessionService,
    private functionEter: FunctionsService,
    private storage: LocalStorageService
  ) {
    this.componentsForm = this.formBulier.group({
      name: '',
      specifications: '',
      photo: ''
    })
  }

  ngOnInit(): void {

    if (this.data.action == 'addComponentes') {
      this.agregarComponentes()
    }

    if (this.data.componentId) {
      this.inicializarCamposTabla()
    }

    if (this.data.action == "cve") {

      let modelo = new Date(this.functionEter.dateIso(this.data.dataEquipo.fabricationDate))
      this.data.dataEquipo.fabricationDate = modelo.getFullYear()
      this.data.dataEquipo.purchaseDate = this.functionEter.dateIso(this.data.dataEquipo.purchaseDate)
      this.dataComponentes = this.data.dataEquipo.components
      this.titleLabel = `${this.dataComponentes.length}  componentes`

      this.paramsCompoentes.forEach(element => {
        if (element.id == 'equipmentId') {
          element.value = this.data.dataEquipo.id
        }

      });
      this.recargarTablaComponentes.emit()

      for (let element of this.dataComponentes) {
        element.photo = `${EndpointDictionary.Base._BASE_URL_V2}${element.photo}/${this.companyId}`
      }
      this.message.closeLoading()

    } else {
      this.dataComponentes = []
    }

  }


  agregarComponentes() {
    let value: number = this.data.componentsNumber

    for (let i = 0; i < value; i++) {

      this.formComponentes.push({
        name: "",
        specifications: "",
        photo: null,
        index: `${i}`
      })
    }
  }

  async inicializarCamposTabla() {
    //inicializar campor de componentes de tabla
    if (this.data.componentId) {
      let resComponent: Array<ComponentEquipment> = await this.http.getDataBody(`${this.urlPostComponentes}/${this.data.componentId}`)
      if (resComponent) {
        let bodyComponents = resComponent[0]
        this.fileOld[0]['value'] = bodyComponents.photo
        this.fileInputComponente.label = bodyComponents.photo

        for (let controls of Object.keys(this.componentsForm.controls)) {
          if (bodyComponents[controls]) {
            this.componentsForm.controls[controls].setValue(bodyComponents[controls].toString())
          }
        }
      }
    }
  }


  fileSaveComponente($event, img) {

    if (img == 'fileTable') {
      this.file = $event.new
    } else {
      this.formComponentes[img].photo = $event.new
      // this.formComponentes.forEach((element, index) => {
      //   if(index == img){
      //     element.photo = $event.new
      //   }
      // });

    }

  }

  async multipartForm(element) {

    if (element.photo != null) {
      let formImg = this.formFile.createMultipartForm(element.photo)
      let res: GenericResponse = await this.http.postDataBody(`${EndpointDictionary.Docs.DOCS_SUBIR}`, formImg)
      element.photo = (res)
    }

  }

  async saveComponente(form) {
    if (this.data.action == 'addComponentes') {
      this.formComponentes.forEach(element => {
        this.multipartForm(element)
      });
      let valid: boolean = true
      for (const validar of this.formComponentes) {
        if (validar.name == "" || validar.specifications == "") {
          valid = false
          break;
        }
      }
      if (valid) {
        this.dialogRef.close(this.formComponentes)
      } else {
        this.message.Error('Error', "Falta llenar campos")
      }

    } else {

      if (this.data.action == 'addComponente') {
        this.message.openLoading('Cargando', 'Agregando Componente')

        //agregar componente desde tabla

        if (this.file != null) {
          //console.log("FILE",this.file)
          let formImg = this.formFile.createMultipartForm(this.file)
          let res: GenericResponse = await this.http.postDataBody(`${EndpointDictionary.Docs.DOCS_SUBIR}`, formImg)
          form.photo = (res)
        } else {
          // console.log('no se agrego imagen al componente')
        }
        let formSave = {
          name: form.name,
          specifications: form.specifications,
          photo: form.photo,
          equipmentId: this.session.getData('equipment').id
        }

        //console.log(formSave)

          let res: GenericResponse = await this.http.postDataBody(`${this.urlPostComponentes}`, formSave)
          //console.log(res)
          if (res) {
            this.message.closeLoading()
            this.message.SuccessToast('Componente agregado correctamente')
          } else {
            this.message.closeLoading()
            this.message.Error('Error', `${res['message']}`)
          }


        this.dialogRef.close()

      } else {
        this.message.openLoading('Cargando', 'Actualizando Componente')
        //actualizar componente desde tabla

        if (this.file == null) {
          console.log('no se actualizo imagen')
          form.photo = this.fileOld[0]['value']
        } else {
          let formImg = this.formFile.createMultipartForm(this.file, this.fileOld)
          let res: GenericResponse = await this.http.postDataBody(`${EndpointDictionary.Docs.DOCS_SUBIR}`, formImg)
          form.photo = (res)
        }
        let formSave = {
          id: this.data.componentId,
          name: form.name,
          specifications: form.specifications,
          photo: form.photo,
          equipmentId: this.session.getData('equipment').id
        }
        // console.log(formSave)

          let res: GenericResponse = await this.http.putDataBody(`${this.urlPostComponentes}`, formSave)

          if (res) {
            this.message.closeLoading()
            this.message.SuccessToast('Componente actualizado correctamente')
          } else {
            this.message.closeLoading()
            this.message.Error('Error', `${res['error']}`)
          }

        this.dialogRef.close()

      }

    }


  }

  errorMessage() {
    this.message.Error('Error', 'complete los campos')
  }


}
